import { EventTypes } from '../utils/events';

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'CORE_UI:FETCH_TYPES_SUCCESS': {
            // Filter out obsolete event types
            const filteredData = { ...action.data };
            if (filteredData.tms?.eventTypes) {
                filteredData.tms.eventTypes = filteredData.tms.eventTypes.filter(eventType => {
                    return eventType.id !== EventTypes.NON_TENNIS && eventType.id !== EventTypes.VIRTUAL;
                });
            }

            return {
                ...state,
                types: {
                    ...state.types,
                    ...filteredData,
                },
            };
        }

        case 'CORE_UI:FETCH_SEARCH_TYPES_SUCCESS': {
            return {
                ...state,
                types: {
                    ...state.types,
                    search: action.data,
                },
            };
        }

        case 'CORE_UI:FETCH_TIMEZONE_SUCCESS': {
            return {
                ...state,
                types: action.data,
            };
        }

        case 'CORE_UI:FETCH_UTRRANGE_TYPES_SUCCESS': {
            return {
                ...state,
                types: {
                    ...state.types,
                    utrRange: action.data,
                },
            };
        }
        case 'CORE_UI:FETCH_PICKLEBALL_RATING_TYPES_SUCCESS': {
            return {
                ...state,
                types: {
                    ...state.types,
                    pickleballRating: action.data,
                },
            };
        }

        default:
            return state;
    }
};
